import { CoreConfig } from '@core/types';
import { LAYOUT_VERSION } from 'app/layout-version';
 
/**
 * Default App Config
 *
 * ? TIP:
 *
 * Change app config based on your preferences.
 * You can also change them on each component basis. i.e `app/main/pages/authentication/auth-login-v1/auth-login-v1.component.ts`
 *
 * ! IMPORTANT: If the enableLocalStorage option is true then make sure you clear the browser local storage(https://developers.google.com/web/tools/chrome-devtools/storage/localstorage#delete).
 *  ! Otherwise, it will not take the below config changes and use stored config from local storage.
 *
 */
 
// Versión 1 = layout de master (horizontal, marca Beliv); 2 = layout nuevo
const isMasterLayout = LAYOUT_VERSION === 1;

// prettier-ignore
export const coreConfig: CoreConfig = {
  app: isMasterLayout ? {
    appName     : 'Beliv',                                        // App Name
    appTitle    : 'Beliv - App',                                  // App Title
    appLogoImage: 'assets/images/logo/beliv-color.png',                  // App Logo
    appLogoAlternative: 'assets/images/logo/beliv-color.png',
    appLogoIco: 'assets/images/logo/logo.png',
    appLanguage : 'es',                                           // App Default Language (en, fr, de, pt etc..)
  } : {
    appName     : 'Brain',                                        // App Name
    appTitle    : 'B.R.A.I.N.',                                  // App Title
    appLogoImage: 'assets/images/logo/brain_logo.png',                  // App Logo
    appLogoAlternative: 'assets/images/logo/brain_logo.png',
    appLogoIco: 'assets/images/logo/brain_logo.png',
    appLanguage : 'es',                                           // App Default Language (en, fr, de, pt etc..)
  },
  layout: {
    skin  : 'default',                        // default, dark, bordered, semi-dark
    type  : isMasterLayout ? 'horizontal' : 'home-layout',   // vertical, horizontal, home-layout
    animation : 'fadeIn',                     // fadeInLeft, zoomIn , fadeIn, none
    menu : {
      hidden               : false,           // Boolean: true, false
      collapsed            : false,           // Boolean: true, false
    },
    // ? For horizontal menu, navbar type will work for navMenu type
    navbar: {
      hidden               : false,           // Boolean: true, false
      type                 : 'fixed-top',  // navbar-static-top, fixed-top, floating-nav, d-none
      background           : 'navbar-light',  // navbar-light. navbar-dark
      customBackgroundColor: true,            // Boolean: true, false
      backgroundColor      : ''               // BS color i.e bg-primary, bg-success
    },
    footer: {
      hidden               : false,           // Boolean: true, false
      type                 : 'footer-static', // footer-static, footer-sticky, d-none
      background           : 'footer-light',  // footer-light. footer-dark
      customBackgroundColor: false,           // Boolean: true, false
      backgroundColor      : ''               // BS color i.e bg-primary, bg-success
    },
    enableLocalStorage: true,
    customizer  : false,                       // Boolean: true, false (Enable theme customizer)
    scrollTop   : true,                       // Boolean: true, false (Enable scroll to top button)
    buyNow      : false                        // Boolean: true, false (Set false in real project, For demo purpose only)
  }
}
 
